import axios from 'axios';

const getAppleOAuthTokenApi = async (code, state) => {
  return await axios.post(`/api/social/getAppleOAuthToken`, { code, state });
};

const appleCallbackApi = async (accessToken, email, identityToken) => {
  return await axios.post(`/api/social/v2/appleCallback`, { accessToken, email, identityToken });
};

export { getAppleOAuthTokenApi, appleCallbackApi };
